export default __webpack_public_path__ + "static/media/thirst.5d8c8faf.png";